import styled from 'styled-components';

const Icon = styled.div`
  display: inline-flex;
  cursor: pointer;
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 4px;
  }
  .moreicon {
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
  }
  @media (max-width: 449px) {
    :hover {
      background-color: transparent;
    }
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    .moreicon {
      width: 16px;
      height: 16px;
    }
  }
`;
export { Icon };
